import {
  CreateExclusionGroupEntityFe,
  ExclusionGroupEntityDto,
} from "@intelligems/ig-types";

export const sortByOrder = (
  a: { order: number },
  b: { order: number }
): number => {
  if (a.order > b.order) {
    return 1;
  }
  if (a.order < b.order) {
    return -1;
  }
  return 0;
};

export const genericSortByOrder = <T extends { order?: number | undefined }>(
  a: T,
  b: T
): number => {
  if ((a.order || 0) > (b.order || 0)) {
    return 1;
  }
  if ((a.order || 0) < (b.order || 0)) {
    return -1;
  }
  return 0;
};

export const genericDescSort = <T>(a: T, b: T, sortVal?: string): number => {
  if (a[sortVal ?? "value"] < b[sortVal ?? "value"]) {
    return 1;
  }
  if (a[sortVal ?? "value"] > b[sortVal ?? "value"]) {
    return -1;
  }
  return 0;
};

export const genericAscSort = <T>(a: T, b: T, sortVal?: string): number => {
  if (a[sortVal ?? "value"] > b[sortVal ?? "value"]) {
    return 1;
  }
  if (a[sortVal ?? "value"] < b[sortVal ?? "value"]) {
    return -1;
  }
  return 0;
};

export const genericSort = <T>(a: T, b: T, sortVal: string): number => {
  if (a[sortVal] > b[sortVal]) {
    return 1;
  }
  if (a[sortVal] < b[sortVal]) {
    return -1;
  }
  return 0;
};

export const customExclusionGroupSelectSort = <
  T extends { exclusionGroupName: string },
>(
  a: T,
  b: T
) => {
  // If both items have exclusionGroupName as "Non-Exclusive Tests", no sorting needed
  if (
    a.exclusionGroupName === "Non-Exclusive Tests" &&
    b.exclusionGroupName === "Non-Exclusive Tests"
  ) {
    return 0;
  }

  // If only one of the items has exclusionGroupName as "Non-Exclusive Tests", it should come first
  if (a.exclusionGroupName === "Non-Exclusive Tests") {
    return -1;
  }
  if (b.exclusionGroupName === "Non-Exclusive Tests") {
    return 1;
  }

  // If none of the items have exclusionGroupName as "Non-Exclusive Tests",
  // then sort alphabetically based on exclusionGroupName
  if (a.exclusionGroupName < b.exclusionGroupName) {
    return -1;
  }
  if (a.exclusionGroupName > b.exclusionGroupName) {
    return 1;
  }
  return 0;
};

export const overviewTableSortOrder = {
  all: 0,
  Desktop: 1,
  Mobile: 2,
  New: 3,
  Returning: 4,
  Direct: 5,
  Email: 6,
  Referral: 7,
  "Organic Social": 8,
  "Paid Social": 9,
  "Organic Search": 10,
  "Paid Search": 11,
  "Paid Shopping": 12,
  SMS: 13,
  "Other Channel": 14,
  Google: 15,
  Facebook: 16,
  Instagram: 17,
  TikTok: 18,
  Twitter: 19,
  Youtube: 20,
  Klaviyo: 21,
  "Other Traffic Source": 22,
  Other: 23,
};

export const customExclusionGroupListSort = (
  currentExperienceId: string | undefined,
  exclusionGroupEntities:
    | CreateExclusionGroupEntityFe[]
    | ExclusionGroupEntityDto[]
) => {
  const tempExclusionGroupEntities = [...exclusionGroupEntities];
  return tempExclusionGroupEntities.sort((a, b) => {
    if (a.experienceId === undefined && b.experienceId !== undefined) {
      return -1; // Put undefined entityId first
    } else if (a.experienceId !== undefined && b.experienceId === undefined) {
      return 1; // Put undefined entityId last
    } else if (
      a.experienceId === currentExperienceId &&
      b.experienceId !== currentExperienceId
    ) {
      return -1; // Put specified currentExperiment entityId first
    } else if (
      a.experienceId !== currentExperienceId &&
      b.experienceId === currentExperienceId
    ) {
      return 1; // Put specified string entityId last
    } else {
      return 0; // Maintain order
    }
  });
};
